module.exports = __webpack_public_path__ + "static/img/科沃斯地宝T50 PRO.f88f664c.png";